export default __webpack_public_path__ + "static/media/Graphics_postcard-01-min.8d470f57.jpg";